import { useEffect } from 'react';

type KeyFilter = (key: string) => boolean;

type options = {
    target?: HTMLElement | Window | null;
};

export const useKeyStroke = (
    keyDefine: Array<string> | string | ((e: KeyboardEvent) => void),
    handler?: (e: KeyboardEvent) => void,
    options?: options
): void => {
    let callback: (e: KeyboardEvent) => void;
    const keyFilter: KeyFilter = (key: string) =>
        Array.isArray(keyDefine) ? keyDefine.includes(key) : key === keyDefine;

    if (typeof keyDefine === 'function') {
        callback = keyDefine;
    } else {
        callback = handler!;
    }

    useEffect(() => {
        const target = options?.target || window;
        const handleKeyDown = (e: KeyboardEvent) => {
            if (keyFilter(e.key)) {
                callback(e);
            }
        };
        target.addEventListener('keydown', handleKeyDown as any);

        return () => {
            target.removeEventListener('keydown', handleKeyDown as any);
        };
    }, [keyDefine, callback]);
};
